/**
 * LoadingOverlay
 *
 * Overlay de tela cheia exibido enquanto os dados de um módulo estão sendo buscados.
 * Aparece com animação suave ao clicar em Aplicar / Atualizar.
 */

import { useSimulatedProgress } from "@/hooks/useSimulatedProgress";
import { LoadingProgressBar } from "@/components/ui/LoadingProgressBar";

interface LoadingOverlayProps {
  message?: string;
}

export function LoadingOverlay({ message = "Buscando dados…" }: LoadingOverlayProps) {
  const percent = useSimulatedProgress();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center animate-overlay-in"
      style={{ background: "rgba(15, 23, 42, 0.35)", backdropFilter: "blur(3px)" }}
    >
      <div className="absolute top-0 left-0 right-0 h-[3px] overflow-hidden bg-brand-900/30">
        <div
          className="h-full bg-brand-400 transition-[width] duration-150 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>

      <div className="animate-card-in bg-white rounded-2xl shadow-modal px-10 py-8 flex flex-col items-center gap-5 min-w-[280px] w-[min(92vw,22rem)]">

        <div className="flex items-end gap-[5px] h-10">
          <div className="w-2.5 rounded-t-sm bg-brand-300 origin-bottom animate-bar-1" style={{ height: "100%" }} />
          <div className="w-2.5 rounded-t-sm bg-brand-400 origin-bottom animate-bar-2" style={{ height: "80%" }} />
          <div className="w-2.5 rounded-t-sm bg-brand-600 origin-bottom animate-bar-3" style={{ height: "100%" }} />
          <div className="w-2.5 rounded-t-sm bg-brand-400 origin-bottom animate-bar-4" style={{ height: "65%" }} />
          <div className="w-2.5 rounded-t-sm bg-brand-300 origin-bottom animate-bar-5" style={{ height: "85%" }} />
        </div>

        <div className="flex flex-col items-center gap-1 text-center">
          <span className="text-sm font-semibold text-slate-700">{message}</span>
          <span className="text-xs text-slate-400">Consultando o Sienge…</span>
        </div>

        <LoadingProgressBar percent={percent} size="lg" className="w-full" />
      </div>
    </div>
  );
}
